var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHammer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0165 5.22058C10.964 3.27307 11.9378 2.29932 13.1478 2.29932C14.3578 2.29932 15.3316 3.27307 17.2791 5.22058L22.2366 10.1781C24.1842 12.1256 25.1579 13.0994 25.1579 14.3094C25.1579 15.5195 24.1842 16.4932 22.2366 18.4407C20.2891 20.3882 19.3154 21.362 18.1053 21.362C16.8953 21.362 15.9216 20.3882 13.9741 18.4407L9.0165 13.4832C7.06899 11.5357 6.09523 10.5619 6.09523 9.35188C6.09523 8.14185 7.06899 7.16809 9.0165 5.22058Z",
    fill: "#33ACFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.84769 14.3143L3.65593 20.5061C3.27173 20.8903 3.07963 21.0824 2.96426 21.2822C2.65116 21.8245 2.65116 22.4927 2.96426 23.035C3.07963 23.2348 3.27172 23.4269 3.6559 23.8111C4.0401 24.1953 4.23223 24.3874 4.43207 24.5028C4.97438 24.8159 5.64252 24.8159 6.18483 24.5028C6.38467 24.3874 6.57677 24.1953 6.96097 23.8111L13.1527 17.6193L9.84769 14.3143Z",
    fill: "#33ACFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4153 9.35676L21.8336 8.93845C22.2178 8.55425 22.4099 8.36215 22.5253 8.16231C22.8384 7.62 22.8384 6.95185 22.5253 6.40955C22.4099 6.20971 22.2178 6.01761 21.8336 5.63341C21.4494 5.24921 21.2573 5.05711 21.0575 4.94173C20.5152 4.62863 19.847 4.62863 19.3047 4.94173C19.1049 5.05711 18.9128 5.24921 18.5286 5.63341L18.1103 6.05172L21.4153 9.35676Z",
    fill: "#33ACFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammer);
export default __webpack_public_path__ + "static/media/hammer.e99935d5e3cf86ccb8a93958624fb65c.svg";
export { ForwardRef as ReactComponent };